import { createQueryClient } from "@/lib/query-client";
import { AuthProvider } from "@/providers/auth-provider";
import { PreferencesProvider } from "@/providers/preferences-provider";
import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Toaster } from "sonner";

const queryClient = createQueryClient();

export const AppProviders = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    <PreferencesProvider>
      <AuthProvider>
        {children}
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </PreferencesProvider>
  </QueryClientProvider>
);
